import { ThemeProvider } from './theme/ThemeContext';
import { GlobalStyle } from './theme/GlobalStyle';
import AppRoutes from './routes';
import { API_URL } from './services/api';
import DemoBanner from './components/DemoBanner';

// Base des appels axios directs ({baseUrl}/api/...) : adresses relatives, identiques au service API.
// Importé par une dizaine de modules : un export manquant donne des requêtes vers /undefined/api/.
export const baseUrl = API_URL;

const App = () => {
  return (
    <ThemeProvider>
      <GlobalStyle />
      <AppRoutes />
      <DemoBanner />
    </ThemeProvider>
  );
};

export default App;
